import React from 'react'

export default ({ ...props }) => (
  <svg width='66' height='74' viewBox='0 0 66 74' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g filter='url(#filter0_dd_2213_12054)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M58.4134 38.1408C59.4404 35.2861 60 32.2084 60 29C60 14.0883 47.9117 2 33 2C18.0883 2 6 14.0883 6 29C6 43.7999 17.9077 55.8186 32.6651 55.998L39 64C44.6131 59.6005 55.5841 48.7937 58.4134 38.1408Z'
        fill='#393838'
      />
    </g>
    <circle cx='23' cy='30' r='3' fill='white' />
    <circle cx='33' cy='30' r='3' fill='white' />
    <circle cx='43' cy='30' r='3' fill='white' />
    <defs>
      <filter
        id='filter0_dd_2213_12054'
        x='0'
        y='0'
        width='66'
        height='74'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2213_12054' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology radius='8' operator='erode' in='SourceAlpha' result='effect2_dropShadow_2213_12054' />
        <feOffset dy='8' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0' />
        <feBlend mode='normal' in2='effect1_dropShadow_2213_12054' result='effect2_dropShadow_2213_12054' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_2213_12054' result='shape' />
      </filter>
    </defs>
  </svg>
)
